module.exports = __webpack_public_path__ + "img/login_left_bg02.1681ece0.png";